import { useQuery } from '@tanstack/react-query';
import { searchNotes } from '../services/api';

export function useNoteSearch(query: string) {
  const trimmed = query.trim();

  const { data, isLoading } = useQuery({
    queryKey: ['noteSearch', trimmed],
    queryFn: () => searchNotes(trimmed),
    enabled: trimmed.length >= 2,
    staleTime: 30_000,
  });

  return {
    results: data?.results ?? [],
    total: data?.total ?? 0,
    isLoading: trimmed.length >= 2 && isLoading,
  };
}
